import { ref } from "vue";

export const useStoreInitializer = (onInit: () => Promise<void>, onInitError: (error: any) => Promise<void>) => {
  const initialization = ref<Promise<void>>();
  const initialized = ref(false);

  function init() {
    if (initialization.value === undefined) {
      initialization.value = onInit().then(() => {
        initialized.value = true;
      }, onInitError);
    }
  }

  return {
    init,
    initialization,
    initialized,
  };
};
